const c = (o) => {
  const t = document.querySelector(o);
  t && t.scrollIntoView({ behavior: "smooth", block: "start" });
}, e = /^(?:\+\d{1,3}\s?)?\d{6,14}$/, s = /^0/, r = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, n = (o) => e.test(o), a = (o) => s.test(o), l = (o) => r.test(o);
export {
  a as hasZero,
  c as manageSmoothScrolling,
  l as validEmail,
  n as validNumber
};
